export default function calculateNumberOfColumns(width) {
    if (width > 990) {
        return Math.floor((width - 200) / 162);
    } else if (width > 544) {
        return Math.floor((width - 24) / 156);
    }
    return Math.floor((width - 8) / 119);
}
